// import core component
import dynamic from "next/dynamic";
import parser from "html-react-parser";

// import custom component
const Button = dynamic(() => import("@/elements/Shared/Button"));
const WhiteSquare = dynamic(
  () => import("@/elements/Shared/DesignComponents/WhiteSquare")
);

// import styles
import styles from "./quote.module.scss";

// import interfaces
import QuoteProps from "@/interfaces/Quote";

export default function Quote({
  isAlternative = false,
  title = "",
  content = "«Notre engagement: des résultats basés sur la confiance, la compétence, l’intégrité et la transparence.»",
  buttonText = "Apprenez à nous connaitre.",
  className,
}: QuoteProps) {
  return (
    <div
      className={`${styles._bg_default} ${
        isAlternative ? styles._alternative : ""
      } ${className}`}
    >
      <div className={`container ${styles._container}`}>
        {title !== "" && <h3 className={styles._title}>{title}</h3>}
        <p
          className={`${styles._text} ${
            isAlternative ? styles._alternative : ""
          }`}
        >
          {parser(content)}
        </p>
        <Button
          path="/contact"
          bg={"white"}
          border={false}
          color={"blue"}
          icon={true}
        >
          {buttonText}
        </Button>
      </div>
      <WhiteSquare position="top-right" isLighter={true} />
    </div>
  );
}
